module.exports = __webpack_public_path__ + "static/alexSiteDemo-40f66bed53cd703e7b94e24d936b5d70.gif";